import React, { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import "./geracaoLeitura.css";
import "react-circular-progressbar/dist/styles.css";
import { weatherIcons } from "../assets/icons.js";
import desempenhoOk from "../assets/images/check.png";
import nuvemChuva from "../assets/images/weatherIcons/10.png";
import alertaDesempenho from "../assets/images/alerta_desempenho.png";
import { adicionarPontosMilhar } from "../utils/adicionarPontosMilhar.js";
import avatarGradiosPositivo from "../assets/images/avatar_like_zoom.png";

import {
    getLista,
    setFiltro,
    getModulos,
    setModoTela,
    setAguardando,
    setDataGrafico,
    getListaCliente,
    incluirEnergiaDia,
    setStatusVisualizado,
    getListaManutencaoTipo,
    getListaGraficoEnergiaDia,
    getListaUnidadeConsumidora,
    getListaGraficoEnergiaDiasMes,
    getListaCalculoAmpliacaoPorUc,
    getListaGraficoEnergiaMesesAno,
    salvarManutencaoSolarHistorico,
    excluirManutencaoSolarHistorico,
    getListaGraficoTodasIntegracoesAgrupadasPorHora,
} from "./geracaoLeituraActions";

import { setEmitirAlertaSonoro } from "../usuario/usuarioActions.js";
import { gerarRelatorio, incluirDownloadRealizado } from "../fatura/faturaActions.js";
import { getListaGeracaoIntegracaoTipo } from "../geracaoIntegracao/geracaoIntegracaoActions.js";

import Th from "../common/table/th";
import Td from "../common/table/td";
import Row from "../common/layout/row";
import Table from "../common/table/table";
import THead from "../common/table/tHead";
import NewTr from "../common/table/newTr";
import TBody from "../common/table/tBody";
import Grid from "../common/layout/grid";
import Select from "../common/form/select";
import Button from "../common/button/button";
import DivBox from "../common/divBox/divBox";
import Content from "../common/template/content";
import { Loading } from "../common/loading/loading";
import noEnergy from "../assets/images/no-energy.png";
import DateFormat from "../common/dateFormat/DateFormat";
import ContentCard from "../common/template/contentCard";
import { DisplayPDF } from "../displayPDF/displayPDF.jsx";
import { GraficoGeral } from "./components/GraficoGeral.jsx";
import { ModalAlert } from "../common/dialog/modalAlert.jsx";
import LabelAndCheckbox from "../common/form/labelAndCheckbox";
import { setArquivoPDF } from "../displayPDF/displayPDFActions";
import ContentCardBody from "../common/template/contentCardBody";
import { CardsTotalizadores } from "./components/CardsTotalizadores.jsx";
import { CardsStatusProducao } from "./components/CardsStatusProducao.jsx";
import { GeracaoLeituraModulos } from "./components/GeracaoLeituraModulos.jsx";
import { LogManutencaoSolarForm } from "./components/LogManutencaoSolarForm.jsx";
import { BotaoCalcularAmpliacao } from "./components/BotaoCalcularAmpliacao.jsx";
import { TabelaCalculoAmpliacao } from "./components/TabelaCalculoAmpliacao.jsx";
import { GeracaoLeituraGraficos } from "./components/GeracaoLeituraGraficos.jsx";
import { LogManutencaoSolarTabela } from "./components/LogManutencaoSolarTabela.jsx";
import { GeracaoLeituraInversores } from "./components/GeracaoLeituraInversores.jsx";
import { LabelSelectUcIconeGestor } from "../common/form/LabelSelectUcIconeGestor.jsx";
import { CircularProgressbarWithChildren, buildStyles } from "react-circular-progressbar";
import { ModalGestorConcessonaria } from "../analise/components/ModalGestorConcessionaria.jsx";
import { SemiCircleProgressBar } from "../common/semiCircleProgressBar/semiCircleProgressBar.jsx";
import { useAlertaSonoro } from "../hooks/useAlertaSonoro.jsx";
import { GeracaoLeituraCardMobile } from "./components/GeracaoLeituraCardMobile.jsx";
import { SaldosUnidadeConsumidora } from "./components/SaldosUnidadeConsumidora.jsx";
import { ArrowOrEqualIcon } from "../common/arrowOrEqualIcon/ArrowOrEqualIcon.jsx";
import { ModalBalancoEnergetico } from "./components/ModalBalancoEnergetico.jsx";
import { StatusLeituraWifi } from "./components/StatusLeituraWifi.jsx";
import { EnergiaCard } from "./components/EnergiaCard.jsx";

let idIntervaloBusca = null;

function GeracaoLeitura(props) {
    const isMobile = window.innerWidth <= 768;
    const corBackgroundMobileCliente = "#023b49";
    const corLuzCentral = "#0a6d85";

    const [state, setState] = useState({
        ultima_atualizacao_lista: DateFormat.formatarDataHoraSqlParaTela(DateFormat.getDataHoraAtual()),
        apenasIndisponiveis: false,
        filtroDesempenhoOtimo: { valor: "instantaneo", ativado: false },
        filtroDesempenhoModerado: { valor: "instantaneo", ativado: false },
        filtroDesempenhoBaixo: { valor: "instantaneo", ativado: false },
        exibirModalLogManutencao: false,
        exibirCalculoAmpliacao: false,
        propsFormularioLogManutencao: {},
        exibirModalGestorConcessionaria: false,
        itemSelecionado: null,
        modoTelaVoltar: "lista",
        registroVoltar: {},
        modoTelaAtual: props.modoTela,
        registroAtual: props.registro,
        exibirModalBalancoEnergetico: false,
    });

    useAlertaSonoro({
        listaFiltrada: filtrarLista(),
        filtro: props.filtro,
        usuarioLogado: props.usuarioLogado,
        STATUS_COR_AMARELA: props.STATUS_COR_AMARELA,
        STATUS_COR_VERMELHA: props.STATUS_COR_VERMELHA,
    });

    useEffect(() => {
        //se ta na tela de grafico dia mes ano, o voltar faz retornar pro modo lista
        const telaGraficoAtiva = ["graficoEnergiaDia", "graficoEnergiaDiasMes", "graficoEnergiaMesesAno"].includes(props.modoTela);
        const isAcessoCliente = props.usuarioLogado && props.usuarioLogado.acesso_cliente;
        setState((prevState) => ({
            ...prevState,
            modoTelaVoltar: telaGraficoAtiva ? (isMobile && isAcessoCliente ? "lista" : "lista") : prevState.modoTelaAtual,
            registroVoltar: telaGraficoAtiva && isMobile ? props.registro : prevState.registroAtual,
            modoTelaAtual: props.modoTela,
            registroAtual: props.registro,
        }));
    }, [props.modoTela]);

    useEffect(() => {
        props.setFiltro({
            ...props.filtro,
            id_cliente: props.usuarioLogado && props.usuarioLogado.acesso_cliente ? props.usuarioLogado.id_cliente : props.filtro.id_cliente,
        });
        props.getListaCliente();
        props.getListaCalculoAmpliacaoPorUc();
        props.getListaGeracaoIntegracaoTipo();
        props.getListaUnidadeConsumidora();
        props.getListaManutencaoTipo();
        atualizarDadosCada5Min();

        return () => {
            cancelarTimerBuscaLista5min();
        };
    }, []);

    function atualizarDadosCada5Min() {
        const cincoMinutosMs = 1000 * 60 * 5;
        buscarDadosTela();
        if (!idIntervaloBusca) {
            console.log("iniciando intervalo busca");
            idIntervaloBusca = setInterval(() => buscarDadosTela(), cincoMinutosMs);
        }
    }

    function cancelarTimerBuscaLista5min() {
        if (idIntervaloBusca !== null) {
            console.log("Cancelando intervalo busca tela");
            clearInterval(idIntervaloBusca);
            idIntervaloBusca = null; // Redefine para garantir que só há um intervalo ativo
        }
    }

    function filtrarLista() {
        const lista = props.lista.filter((item) => {
            const usuarioLogadoAcessoCliente = props.usuarioLogado && props.usuarioLogado.acesso_cliente;
            const filtroClienteValidado = !usuarioLogadoAcessoCliente || item.id_cliente == props.usuarioLogado.id_cliente;
            const filtroUcValidado = !props.filtro.id_unidade_consumidora || item.id_unidade_consumidora == props.filtro.id_unidade_consumidora;
            const filtroIndisponiveis = !state.apenasIndisponiveis || !item.statusVerificado;
            const filtroTipo =
                !props.filtro.id_geracao_integracao_tipo ||
                props.filtro.id_geracao_integracao_tipo == item.id_geracao_integracao_tipo ||
                (Array.isArray(item.id_geracao_integracao_tipo) && item.id_geracao_integracao_tipo.includes(parseInt(props.filtro.id_geracao_integracao_tipo)));

            //pra potencia instantanea só considera os online
            const filtroDesempenhoBaixo =
                !state.filtroDesempenhoBaixo.ativado ||
                (state.filtroDesempenhoBaixo.valor === "instantaneo" &&
                    item.desempenho_solar_instantaneo < 81 &&
                    (item.corStatus === props.STATUS_COR_VERDE || item.corStatus === props.STATUS_COR_AMARELA)) ||
                (state.filtroDesempenhoBaixo.valor === "diario" && item.desempenho_solar_diario < 81) ||
                (state.filtroDesempenhoBaixo.valor === "mensal" && item.desempenho_solar_mensal < 81) ||
                (state.filtroDesempenhoBaixo.valor === "anual" && item.desempenho_solar_anual < 81);
            const filtroDesempenhoModerado =
                !state.filtroDesempenhoModerado.ativado ||
                (state.filtroDesempenhoModerado.valor === "instantaneo" &&
                    item.desempenho_solar_instantaneo >= 81 &&
                    item.desempenho_solar_instantaneo <= 93 &&
                    (item.corStatus === props.STATUS_COR_VERDE || item.corStatus === props.STATUS_COR_AMARELA)) ||
                (state.filtroDesempenhoModerado.valor === "diario" && item.desempenho_solar_diario >= 81 && item.desempenho_solar_diario <= 93) ||
                (state.filtroDesempenhoModerado.valor === "mensal" && item.desempenho_solar_mensal >= 81 && item.desempenho_solar_mensal <= 93) ||
                (state.filtroDesempenhoModerado.valor === "anual" && item.desempenho_solar_anual >= 81 && item.desempenho_solar_anual <= 93);
            const filtroDesempenhoOtimo =
                !state.filtroDesempenhoOtimo.ativado ||
                (state.filtroDesempenhoOtimo.valor === "instantaneo" &&
                    item.desempenho_solar_instantaneo > 93 &&
                    (item.corStatus === props.STATUS_COR_VERDE || item.corStatus === props.STATUS_COR_AMARELA)) ||
                (state.filtroDesempenhoOtimo.valor === "diario" && item.desempenho_solar_diario > 93) ||
                (state.filtroDesempenhoOtimo.valor === "mensal" && item.desempenho_solar_mensal > 93) ||
                (state.filtroDesempenhoOtimo.valor === "anual" && item.desempenho_solar_anual > 93);
            return (
                (filtroClienteValidado && filtroUcValidado && filtroIndisponiveis && filtroTipo && filtroDesempenhoBaixo && filtroDesempenhoModerado && filtroDesempenhoOtimo) ||
                props.filtro.id_agrupador
            );
        });
        return lista;
    }

    function filtroDesempenho(nome_campo) {
        return (
            (state.filtroDesempenhoBaixo.ativado && state.filtroDesempenhoBaixo.valor === nome_campo) ||
            (state.filtroDesempenhoModerado.ativado && state.filtroDesempenhoModerado.valor === nome_campo) ||
            (state.filtroDesempenhoOtimo.ativado && state.filtroDesempenhoOtimo.valor === nome_campo)
        );
    }

    function getCorDesempenho({ valor, minMaxMedium = [30, 80] }) {
        const colorLow = "#c11329";
        const colorMedium = "#d5bb22";
        const colorHigh = "#53d166";
        if (!valor) return null;
        const color = valor < minMaxMedium[0] ? colorLow : valor >= minMaxMedium[0] && valor <= minMaxMedium[1] ? colorMedium : colorHigh;
        return color;
    }

    function getDadosItem(item) {
        const isAcessoCliente = props.usuarioLogado && props.usuarioLogado.acesso_cliente;

        const isMobileCliente = isMobile && isAcessoCliente;

        const exibirCondicaoAdversa = item.percentual_chuva >= 28 && new Date().getDate() <= 10;

        const corPadrao = isMobileCliente ? "#FFF" : "#222";
        const corSaldo = (!item.unidade_geradora && !item.unidade_remota) || parseFloat(item.saldo_geracao) ? corPadrao : "#890000";
        const corTabelaSaldo = (!item.unidade_geradora && !item.unidade_remota) || parseFloat(item.saldo_geracao) ? "transparent" : "#ff6381";
        const classeIconeSaldo =
            item.saldo_geracao > item.saldo_geracao_mes_anterior
                ? "arrowUpGreen"
                : item.saldo_geracao < item.saldo_geracao_mes_anterior
                  ? "arrowDownRed"
                  : item.saldo_geracao == item.saldo_geracao_mes_anterior
                    ? "equalBlue"
                    : null;
        const indicadorSaldo = (
            <span
                style={{
                    marginLeft: classeIconeSaldo ? 2 : 0,
                    padding: "2px 2px 0px",
                }}
            >
                <ArrowOrEqualIcon iconName={classeIconeSaldo} />
            </span>
        );

        const calculoAmpliacao = props.listaCalculoAmpliacaoPorUc.find((calc) => calc.id_unidade_consumidora == item.id_unidade_consumidora);
        return { exibirCondicaoAdversa, corSaldo, corTabelaSaldo, classeIconeSaldo, indicadorSaldo, calculoAmpliacao };
    }

    function listar() {
        const isAcessoCliente = props.usuarioLogado && props.usuarioLogado.acesso_cliente;
        const listaFiltrada = filtrarLista();
        const telaDetalhesAtiva = !!props.filtro.id_agrupador;
        const usuarioAdmLogado = props.usuarioLogado && !props.usuarioLogado.acesso_cliente;
        const bgButton = "#c1faff";

        const isMobileCliente = isMobile && isAcessoCliente;

        return (
            <ContentCard style={{ color: isMobileCliente ? "#FFF" : null }}>
                <ContentCardBody>
                    {!props.filtro.id_agrupador &&
                        (isMobileCliente ? null : (
                            <>
                                <Row
                                    style={{
                                        marginBottom: 5,
                                        justifyContent: "space-between",
                                        paddingInline: 10,
                                    }}
                                >
                                    <GraficoGeral
                                        visible={props.modoTela === "lista" && (window.innerWidth > 768 || (props.usuarioLogado && !props.usuarioLogado.acesso_cliente))}
                                    />
                                    <Grid cols="12 12 12 6">
                                        {window.innerWidth > 768 ? (
                                            <Row>
                                                <CardsTotalizadores usuarioLogado={props.usuarioLogado} lista={props.lista} />
                                                <CardsStatusProducao
                                                    coresStatus={{
                                                        STATUS_COR_AMARELA: props.STATUS_COR_AMARELA,
                                                        STATUS_COR_VERMELHA: props.STATUS_COR_VERMELHA,
                                                        STATUS_COR_VERDE: props.STATUS_COR_VERDE,
                                                    }}
                                                    lista={listaFiltrada}
                                                    telaDetalhesAtiva={telaDetalhesAtiva}
                                                    filtroDesempenhoOtimo={state.filtroDesempenhoOtimo}
                                                    filtroDesempenhoModerado={state.filtroDesempenhoModerado}
                                                    filtroDesempenhoBaixo={state.filtroDesempenhoBaixo}
                                                    setFiltroDesempenhoOtimo={(valor) => setState({ ...state, filtroDesempenhoOtimo: valor })}
                                                    setFiltroDesempenhoModerado={(valor) => setState({ ...state, filtroDesempenhoModerado: valor })}
                                                    setFiltroDesempenhoBaixo={(valor) => setState({ ...state, filtroDesempenhoBaixo: valor })}
                                                />
                                            </Row>
                                        ) : (
                                            <details
                                                open={props.usuarioLogado && !props.usuarioLogado.acesso_cliente}
                                                style={{
                                                    marginTop: 20,
                                                    padding: 20,
                                                    fontSize: "1.1rem",
                                                    border: "1px solid #ddd",
                                                    borderRadius: 5,
                                                }}
                                            >
                                                <summary>
                                                    <b>Exibir totalizadores</b>
                                                </summary>
                                                <Row style={{ marginTop: 10 }}>
                                                    <GraficoGeral visible={props.usuarioLogado && props.usuarioLogado.acesso_cliente} />
                                                    <CardsTotalizadores usuarioLogado={props.usuarioLogado} lista={props.lista} />
                                                    <CardsStatusProducao
                                                        coresStatus={{
                                                            STATUS_COR_AMARELA: props.STATUS_COR_AMARELA,
                                                            STATUS_COR_VERMELHA: props.STATUS_COR_VERMELHA,
                                                            STATUS_COR_VERDE: props.STATUS_COR_VERDE,
                                                        }}
                                                        lista={listaFiltrada}
                                                        filtroDesempenhoOtimo={state.filtroDesempenhoOtimo}
                                                        filtroDesempenhoModerado={state.filtroDesempenhoModerado}
                                                        filtroDesempenhoBaixo={state.filtroDesempenhoBaixo}
                                                        setFiltroDesempenhoOtimo={(valor) => setState({ ...state, filtroDesempenhoOtimo: valor })}
                                                        setFiltroDesempenhoModerado={(valor) => setState({ ...state, filtroDesempenhoModerado: valor })}
                                                        setFiltroDesempenhoBaixo={(valor) => setState({ ...state, filtroDesempenhoBaixo: valor })}
                                                    />
                                                </Row>
                                            </details>
                                        )}
                                    </Grid>
                                </Row>
                            </>
                        ))}
                    <Row>
                        {props.filtro.id_agrupador ? null : (
                            <>
                                {props.usuarioLogado && !props.usuarioLogado.acesso_cliente ? (
                                    <Select
                                        name="id_cliente"
                                        options={props.listaCliente.filter((item) => props.listaUnidadeConsumidora.find((uc) => uc.id_cliente == item.id && uc.geracao_integracao))}
                                        label="Cliente"
                                        cols="12 5 5 5"
                                        placeholder="Selecione o Cliente"
                                        value={props.filtro.id_cliente}
                                        onChange={(value) => {
                                            props.setFiltro({
                                                ...props.filtro,
                                                id_cliente: value,
                                                id_unidade_consumidora: null,
                                            });
                                            buscarDadosTela();
                                        }}
                                    />
                                ) : null}
                                {props.usuarioLogado && props.usuarioLogado.acesso_cliente && window.innerWidth <= 768 ? null : (
                                    <Select
                                        name="id_unidade_consumidora"
                                        options={props.listaUnidadeConsumidora.filter((item) => {
                                            if (props.usuarioLogado && props.usuarioLogado.acesso_cliente) {
                                                return props.usuarioLogado.id_cliente == item.id_cliente && item.geracao_integracao;
                                            } else {
                                                return (!props.filtro.id_cliente || props.filtro.id_cliente == item.id_cliente) && item.geracao_integracao;
                                            }
                                        })}
                                        label={
                                            <LabelSelectUcIconeGestor
                                                filtro={props.filtro}
                                                listaUnidadeConsumidora={props.listaUnidadeConsumidora}
                                                setExibirModal={(ucFiltro) =>
                                                    setState({
                                                        ...state,
                                                        exibirModalGestorConcessionaria: true,
                                                        itemSelecionado: ucFiltro,
                                                    })
                                                }
                                            />
                                        }
                                        cols={props.usuarioLogado && props.usuarioLogado.acesso_cliente ? "12 12 12 12" : "12 5 5 5"}
                                        placeholder="Selecione a UC"
                                        value={props.filtro.id_unidade_consumidora}
                                        onChange={(value) => {
                                            const ucSelecionada = props.listaUnidadeConsumidora.find((uc) => uc.id == value) || {};
                                            const acessoCliente = props.usuarioLogado && props.usuarioLogado.acesso_cliente;
                                            const idCliente = ucSelecionada.id_cliente || props.filtro.id_cliente;
                                            props.setFiltro({
                                                ...props.filtro,
                                                id_cliente: acessoCliente ? props.usuarioLogado.id_cliente : idCliente,
                                                id_unidade_consumidora: value,
                                            });
                                            buscarDadosTela();
                                        }}
                                    />
                                )}
                                {props.usuarioLogado && !props.usuarioLogado.acesso_cliente ? (
                                    <Select
                                        name="id_geracao_integracao_tipo"
                                        options={props.listaGeracaoIntegracaoTipo}
                                        label="Tipo"
                                        cols={"12 2 2 2"}
                                        placeholder="Selecione o Tipo"
                                        value={props.filtro.id_geracao_integracao_tipo}
                                        onChange={(value) => {
                                            props.setFiltro({
                                                ...props.filtro,
                                                id_geracao_integracao_tipo: value,
                                            });
                                            buscarDadosTela();
                                        }}
                                    />
                                ) : null}
                                {isMobileCliente ? (
                                    <Grid
                                        cols={"10 4 4 4"}
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            marginBottom: 35,
                                        }}
                                    >
                                        <Button
                                            solid={true}
                                            style={{ color: "#fff", height: 60 }}
                                            text={
                                                <span style={{ fontSize: "0.8rem" }}>
                                                    {!!props.filtro.agrupar_por_uc ? <i className="fas fa-check-square" /> : <i className="fas fa-square" />} Agrupar Gerador que
                                                    Possui Inversores de Marcas Diferentes
                                                </span>
                                            }
                                            type={"info"}
                                            event={(e) => {
                                                props.setFiltro({
                                                    ...props.filtro,
                                                    agrupar_por_uc: !props.filtro.agrupar_por_uc,
                                                });
                                                buscarDadosTela();
                                            }}
                                        />
                                    </Grid>
                                ) : (
                                    <Grid
                                        cols={"12 4 4 4"}
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            paddingTop: 11,
                                        }}
                                    >
                                        <label style={getStyleSlimCard("#17a2b8", "#ffffff")} htmlFor="filtro-agrupar-por-uc">
                                            <LabelAndCheckbox
                                                style={{ justifyContent: "center" }}
                                                readOnly={props.aguardando}
                                                modoCard={true}
                                                colorIcon="#FFF"
                                                id="filtro-agrupar-por-uc"
                                                label="Agrupar Inversores Diferentes"
                                                onChange={(e) => {
                                                    props.setFiltro({
                                                        ...props.filtro,
                                                        agrupar_por_uc: !props.filtro.agrupar_por_uc,
                                                    });
                                                    buscarDadosTela();
                                                }}
                                                value={!!props.filtro.agrupar_por_uc}
                                            />
                                        </label>
                                    </Grid>
                                )}
                                {isMobileCliente ? (
                                    <Grid
                                        cols={"2 1 1 1"}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            flexDirection: "column",
                                            paddingLeft: window.innerWidth < 992 ? 0 : null,
                                            marginBottom: 35,
                                        }}
                                    >
                                        <Button
                                            solid={true}
                                            style={{ color: "#fff", transform: "scaleX(-1)", padding: 2, height: 25 }}
                                            text={<i style={{ fontSize: "0.8rem" }} className={props.usuarioLogado.emitir_alerta_sonoro ? "far fa-bell" : "far fa-bell-slash"} />}
                                            type={"warning"}
                                            event={props.setEmitirAlertaSonoro}
                                        />
                                        <Button
                                            style={{ color: "#fff", padding: 2, height: 25 }}
                                            solid={true}
                                            text={<i style={{ fontSize: "0.8rem" }} className={"fas fa-sync"} />}
                                            type={"primary"}
                                            event={() => {
                                                buscarDadosTela();
                                            }}
                                        />
                                    </Grid>
                                ) : (
                                    <Grid
                                        cols={"12 1 1 1"}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            paddingLeft: window.innerWidth < 992 ? 0 : null,
                                            marginTop: 13,
                                        }}
                                    >
                                        <Button
                                            solid={true}
                                            style={{
                                                color: "#fff",
                                                transform: "scaleX(-1)",
                                            }}
                                            text={
                                                props.usuarioLogado.emitir_alerta_sonoro ? (
                                                    <i style={{ fontSize: "1.2rem" }} className="far fa-bell" />
                                                ) : (
                                                    <i style={{ fontSize: "1.2rem" }} className="far fa-bell-slash" />
                                                )
                                            }
                                            type={"warning"}
                                            event={props.setEmitirAlertaSonoro}
                                        />
                                    </Grid>
                                )}
                                {(props.usuarioLogado && props.usuarioLogado.acesso_cliente && window.innerWidth <= 768) || isMobileCliente ? null : (
                                    <Grid
                                        cols="12 4 4 4"
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            paddingTop: 11,
                                        }}
                                    >
                                        <label style={getStyleSlimCard("#f56969", "#ffffff")} htmlFor="filtro-apenas-indisponiveis">
                                            <LabelAndCheckbox
                                                style={{ justifyContent: "center" }}
                                                readOnly={props.aguardando}
                                                modoCard={true}
                                                colorIcon="#FFF"
                                                id="filtro-apenas-indisponiveis"
                                                label="Apenas Indisponíveis"
                                                onChange={(e) =>
                                                    setState({
                                                        ...state,
                                                        apenasIndisponiveis: !state.apenasIndisponiveis,
                                                    })
                                                }
                                                value={!!state.apenasIndisponiveis}
                                            />
                                        </label>
                                    </Grid>
                                )}
                                {isMobileCliente ? null : (
                                    <Grid
                                        cols={"12 3 3 3"}
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            paddingBottom: 8,
                                        }}
                                    >
                                        <span style={{ textAlign: "right", width: "100%", color: "#777" }}>
                                            <i>
                                                {window.innerWidth > 990 && window.innerWidth < 1600 ? "At. " : "Atualizada em "}
                                                {state.ultima_atualizacao_lista}
                                            </i>
                                        </span>
                                        <Button
                                            text="Recarregar"
                                            type={"primary"}
                                            event={() => {
                                                buscarDadosTela();
                                            }}
                                        />
                                    </Grid>
                                )}
                            </>
                        )}
                    </Row>
                    {telaDetalhesAtiva ? (
                        <Row alignRight>
                            <Grid
                                cols="12 4 4 2"
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: "15px",
                                }}
                            >
                                <Button
                                    text="Voltar"
                                    type={"warning"}
                                    icon={"fa fa-chevron-left"}
                                    event={() => {
                                        props.setModoTela("lista", {});
                                        props.setFiltro({
                                            ...props.filtro,
                                            id_agrupador: null,
                                        });
                                        buscarDadosTela();
                                    }}
                                />
                            </Grid>
                        </Row>
                    ) : null}
                    {isMobileCliente ? (
                        listaFiltrada.map((item, index) => {
                            const { exibirCondicaoAdversa, corSaldo, corTabelaSaldo, indicadorSaldo, calculoAmpliacao } = getDadosItem(item);
                            const totalSegmentos = 30;
                            const percentualSolar = Math.max(0, Math.min(100, Number(item.desempenho_solar_instantaneo) || 0));
                            const segmentosAtivos = Math.round((percentualSolar / 100) * totalSegmentos);

                            return (
                                <ContentCard
                                    key={index}
                                    style={{
                                        background: `radial-gradient(circle at 50% 32%, ${corLuzCentral} 0%, ${corLuzCentral} 5%, ${corBackgroundMobileCliente} 12%)`,
                                        color: "#FFF",
                                        marginBottom: 15,
                                        borderRadius: 10,
                                        padding: 5,
                                    }}
                                >
                                    <Row>
                                        <Grid cols="12 12 12 12" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                            <b style={{ paddingLeft: 10 }}>Unidade Consumidora</b>
                                            {item.nome_unidade_consumidora}
                                        </Grid>
                                        <Grid cols="12 12 12 12" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <StatusLeituraWifi style={{ display: "flex", alignItems: "center" }} item={item} />
                                        </Grid>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                flexWrap: "wrap",
                                                alignItems: "center",
                                                marginTop: 10,
                                                width: "95%",
                                                maxWidth: "360px",
                                                margin: "10px auto",
                                                gap: "12px",
                                                backgroundColor: "transparent",
                                                border: "1px solid rgba(255, 255, 255, 0.70)",
                                                borderRadius: "14px",
                                                backdropFilter: "blur(2px)",
                                            }}
                                        >
                                            <Grid cols="12 12 12 12" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                {[props.STATUS_COR_VERDE, props.STATUS_COR_AMARELA].includes(item.corStatus) ? (
                                                    <div style={{ width: 180, height: 180, padding: "5px", fontSize: "1rem", position: "relative" }}>
                                                        <div style={{ position: "absolute", top: 5, left: 5, width: 170, height: 170, borderRadius: "50%", pointerEvents: "none" }}>
                                                            {Array.from({ length: totalSegmentos }).map((_, indexSegmento) => {
                                                                const ativo = indexSegmento < segmentosAtivos;

                                                                return (
                                                                    <div
                                                                        key={indexSegmento}
                                                                        style={{
                                                                            position: "absolute",
                                                                            width: 14,
                                                                            height: 20,
                                                                            left: "50%",
                                                                            top: "50%",
                                                                            clipPath: "polygon(0% 0%, 100% 0%, 82% 100%, 18% 100%)",
                                                                            background: ativo ? "linear-gradient(180deg, #BFFBFF 0%, #00D1E0 50%, #00a6b5 100%)" : "rgba(180, 220, 225, 0.18)",
                                                                            boxShadow: ativo ? "0 0 6px rgba(0, 209, 224, 0.55)" : "none",
                                                                            transform: `translate(-50%, -50%) rotate(${indexSegmento * (360 / totalSegmentos)}deg) translateY(-76px)`,
                                                                            transformOrigin: "center center",
                                                                        }}
                                                                    />
                                                                );
                                                            })}
                                                        </div>
                                                        <CircularProgressbarWithChildren
                                                            strokeWidth={12}
                                                            styles={buildStyles({ pathColor: "transparent", trailColor: "transparent", textColor: "#000", strokeLinecap: "butt" })}
                                                            value={item.desempenho_solar_instantaneo || 0}
                                                        >
                                                            <div style={{ zIndex: 2, justifyContent: "center", alignItems: "center", display: "flex", flexDirection: "column" }}>
                                                                <p style={{ margin: "11px 0 0 0", fontSize: "1.4rem" }} >{`${Number(item.potencia_instantanea).toFixed(1).replace(".", ",")} kW`}</p>
                                                                <p style={{ margin: "-3px 0 0 0", fontSize: "1rem" }}>{`${Math.round(item.desempenho_solar_instantaneo)} %`}</p>
                                                            </div>
                                                        </CircularProgressbarWithChildren>
                                                    </div>
                                                ) : (
                                                    <div
                                                        title="Sem Geração de Energia"
                                                        style={{
                                                            borderRadius: "50%",
                                                            border: "25px solid #e3e3e3",
                                                            width: 170, //72,
                                                            height: 170, //73,
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                        }}
                                                    >
                                                        <img alt="" src={noEnergy} width={40} height={40} />
                                                    </div>
                                                )}
                                                <b style={{ textAlign: "center" }}>Potência Instantânea</b>
                                            </Grid>

                                            {/* DIA */}
                                            <EnergiaCard
                                                titulo="Energia do Dia"
                                                energia={item.energia_dia}
                                                energiaMax={item.prod_max_esperada_dia_atual}
                                                percentual={item.percentual_producao_energia_dia.toFixed(1).replace(".", ",")}
                                                desempenho={item.desempenho_solar_diario}
                                                unidade="kWh"
                                                tipoGrafico="graficoEnergiaDia"
                                                item={item}
                                                setModoTela={props.setModoTela}
                                                bgButton={bgButton}
                                                getCorDesempenho={props.getCorDesempenho}
                                            />

                                            {/* MÊS */}
                                            <EnergiaCard
                                                titulo="Energia do Mês"
                                                energia={item.energia_mes}
                                                energiaMax={item.prod_max_esperada_mes_atual}
                                                percentual={item.percentual_producao_energia_mes.toFixed(1).replace(".", ",")}
                                                desempenho={item.desempenho_solar_mensal}
                                                unidade="kWh"
                                                tipoGrafico="graficoEnergiaDiasMes"
                                                item={item}
                                                setModoTela={props.setModoTela}
                                                bgButton={bgButton}
                                                getCorDesempenho={props.getCorDesempenho}
                                            />

                                            {/* ANO */}
                                            <EnergiaCard
                                                titulo="Energia do Ano"
                                                energia={adicionarPontosMilhar(
                                                    parseFloat(item.energia_ano)
                                                        ? parseFloat(item.energia_ano) / 1000
                                                        : 0,
                                                    1
                                                )}
                                                energiaMax={item.prod_max_esperada_ano_atual}
                                                percentual={item.percentual_producao_energia_ano.toFixed(1).replace(".", ",")}
                                                desempenho={item.desempenho_solar_anual}
                                                unidade="MWh"
                                                tipoGrafico="graficoEnergiaMesesAno"
                                                item={item}
                                                setModoTela={props.setModoTela}
                                                bgButton={bgButton}
                                                getCorDesempenho={props.getCorDesempenho}
                                            />
                                        </div>
                                        <Grid cols="12 12 12 12">
                                            {item.alerta_desempenho ? (
                                                <div
                                                    title={
                                                        (item.percentual_chuva >= 28 && !item.alerta_limpeza_atrasada
                                                            ? `* Percentual de chuva nos primeiros 10 dias do mês é maior ou igual à 28%: ${adicionarPontosMilhar(
                                                                  item.percentual_chuva
                                                              )}%\n`
                                                            : "") + item.alerta_desempenho
                                                    }
                                                    style={{
                                                        gap: "10px",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        height: "100%",
                                                        backgroundColor: exibirCondicaoAdversa && !item.alerta_limpeza_atrasada ? "#a5b3c1" : "#FFF",
                                                        border: exibirCondicaoAdversa && !item.alerta_limpeza_atrasada ? "2px solid #a5b3c1" : "2px solid #E44556",
                                                        color: "#ff0019",
                                                        borderRadius: "0.3rem",
                                                        padding: 4,
                                                        fontSize: "0.8rem",
                                                        cursor: "help",
                                                        margin: 4,
                                                    }}
                                                >
                                                    <div style={{ width: "20%", display: "flex", justifyContent: "center", alignItems: "center",  marginLeft: 45 }}>
                                                        <img src={alertaDesempenho} alt="" width={50} />
                                                    </div>
                                                    <div style={{ width: "80%", display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "column" }}>
                                                        {exibirCondicaoAdversa && !item.alerta_limpeza_atrasada && <img src={nuvemChuva} alt="" width={40} style={{ margin: 4 }} />}
                                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", fontSize: "15px" }}>Desempenho baixo!</div>
                                                        {exibirCondicaoAdversa && !item.alerta_limpeza_atrasada ? (
                                                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>Condição Climática Adversa</div>
                                                        ) : (
                                                            <>
                                                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                                    Verifique a necessidade de manutenção/limpeza
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            ) : (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        backgroundColor: "#50ffbc",
                                                        // border: "2px solid #CFF3E4",
                                                        padding: 4,
                                                        minHeight: 55,
                                                        borderRadius: "0.3rem",
                                                        cursor: "help",
                                                        margin: 4,
                                                    }}
                                                    title={`- Mês passado: ${(item.desempenho_solar_passado_1_mes || 0).toFixed(1).replace(".", ",")} %\n- 2 meses atrás: ${(
                                                        item.desempenho_solar_passado_2_meses || 0
                                                    )
                                                        .toFixed(1)
                                                        .replace(".", ",")} %\n- 3 meses atrás: ${(item.desempenho_solar_passado_3_meses || 0)
                                                        .toFixed(1)
                                                        .replace(".", ",")} %\n- 4 meses atrás: ${(item.desempenho_solar_passado_4_meses || 0).toFixed(1).replace(".", ",")} %
                                                `}
                                                >
                                                    {/* <img src={desempenhoOk} alt="" width={50} /> */}
                                                    <img src={avatarGradiosPositivo} alt={""} height={50} style={{ filter: "brightness(1.12)" }} />
                                                    <b className="ml-2 text-dark">Bom Desempenho!</b>
                                                </div>
                                            )}
                                        </Grid>

                                        <Grid cols="12 12 12 12" style={{ display: "flex" }}>
                                            <Button
                                                style={{
                                                    height: 40,
                                                    margin: 2,
                                                    padding: 0,
                                                    border: "1px solid #FFF",
                                                }}
                                                text={"Exibir mais informações"}
                                                icon={"fas fa-expand-arrows-alt"}
                                                solid={true}
                                                type={"info"}
                                                event={() => {
                                                    props.setModoTela("detalharCardMobile", item);
                                                }}
                                            />
                                        </Grid>
                                    </Row>
                                </ContentCard>
                            );
                        })
                    ) : (
                        <Table responsive>
                            <THead>
                                <NewTr backgroundColorTr={"#FFFFFF"} backgroundColorTd={"#FFFFFF"}>
                                    {usuarioAdmLogado && (
                                        <Th sticky alignCenter verticalAlign="top">
                                            Cliente
                                        </Th>
                                    )}
                                    <Th sticky alignCenter verticalAlign="top">
                                        Unidade Consumidora
                                    </Th>
                                    <Th sticky alignCenter verticalAlign="top">
                                        Saldo Prod. Solar
                                    </Th>
                                    <Th sticky alignCenter verticalAlign="top" maxWidth={70}>
                                        <div>Status</div>
                                        <div>Data/Hora</div>
                                    </Th>
                                    <Th sticky alignCenter verticalAlign="top">
                                        Tipo
                                    </Th>
                                    <Th sticky alignCenter verticalAlign="top">
                                        Potência Instantânea
                                    </Th>

                                    {props.filtro.id_agrupador ? (
                                        <Th sticky alignCenter verticalAlign="top">
                                            Energia Instantânea
                                        </Th>
                                    ) : (
                                        <>
                                            <Th sticky alignCenter verticalAlign="top">
                                                Energia do Dia
                                            </Th>
                                            <Th sticky alignCenter verticalAlign="top">
                                                Energia do Mês
                                            </Th>
                                            <Th sticky alignCenter verticalAlign="top">
                                                Energia do Ano
                                            </Th>
                                            <Th sticky alignCenter verticalAlign="top">
                                                Alerta de Desempenho
                                            </Th>
                                            <Th colSpan="2" sticky alignCenter verticalAlign="top">
                                                Potência Instalada
                                                <div style={{ display: "flex", justifyContent: "center" }}>
                                                    <div style={{ display: "flex", justifyContent: "center", width: "49%" }}>Módulos</div>
                                                    <div style={{ display: "flex", justifyContent: "center", width: "2%" }}>|</div>
                                                    <div style={{ display: "flex", justifyContent: "center", width: "49%" }}>Inversores</div>
                                                </div>
                                            </Th>
                                            {props.usuarioLogado.acesso_manutencao_solar_visualizar ? (
                                                <Th sticky alignCenter verticalAlign="top">
                                                    Log de Manutenções
                                                </Th>
                                            ) : null}
                                        </>
                                    )}

                                    {props.filtro.id_agrupador ? null : (
                                        <>
                                            <Th colSpan="2" sticky alignCenter verticalAlign="top">
                                                Dados Meteorológicos
                                            </Th>
                                            <Th sticky alignCenter verticalAlign="top">
                                                Detalhes das últimas 24h
                                            </Th>
                                        </>
                                    )}
                                </NewTr>
                            </THead>

                            <TBody>
                                {listaFiltrada.map((item, index) => {
                                    const { exibirCondicaoAdversa, corSaldo, corTabelaSaldo, indicadorSaldo, calculoAmpliacao } = getDadosItem(item);

                                    return (
                                        <NewTr
                                            key={index}
                                            backgroundColorTr={"#FFFFFF"}
                                            backgroundColorTd={"#FFFFFF"}
                                            botoes={[]}
                                            highlightAlert={item.corStatus !== props.STATUS_COR_VERDE && window.innerWidth < 768}
                                        >
                                            {usuarioAdmLogado && <Td minWidth={100}>{item.nome_cliente}</Td>}
                                            <Td minWidth={usuarioAdmLogado ? 100 : 200}>
                                                <div>{item.nome_unidade_consumidora}</div>
                                            </Td>
                                            <Td fontSize="0.8rem" minWidth={80} alignCenter>
                                                <SaldosUnidadeConsumidora setModoTela={props.setModoTela} item={item} getDadosItem={getDadosItem} />
                                                <Button
                                                    style={{ margin: "5px 0px", padding: 0, height: 32, width: 100, lineHeight: "0.8rem" }}
                                                    type="success"
                                                    title="Balanço Energético"
                                                    text={
                                                        <div>
                                                            <div style={{ fontSize: "0.8rem", marginBlock: 1 }}>
                                                                <i className="fas fa-balance-scale mr-2"></i>
                                                                <span className="mr-2">Balanço</span>
                                                            </div>
                                                            <div style={{ fontSize: "0.8rem" }}>
                                                                <i className="fas fa-bolt ml-2 mr-1"></i> Energético
                                                            </div>
                                                        </div>
                                                    }
                                                    event={() => setState({ ...state, exibirModalBalancoEnergetico: true, itemSelecionado: item })}
                                                />
                                            </Td>

                                            <Td alignCenter minWidth={60} style={{ cursor: "help" }}>
                                                <StatusLeituraWifi item={item} />
                                            </Td>

                                            <Td alignCenter>
                                                {item.tipo instanceof Array
                                                    ? item.tipo.map((tipo, i) => (
                                                          <p key={i} style={{ margin: 0 }}>
                                                              {tipo}
                                                          </p>
                                                      ))
                                                    : item.tipo}
                                            </Td>

                                            <Td alignCenter backgroundColor={filtroDesempenho("instantaneo") ? "#eee" : null}>
                                                {[props.STATUS_COR_VERDE, props.STATUS_COR_AMARELA].includes(item.corStatus) ? (
                                                    <div style={{ width: 85, height: 85, padding: "5px", fontSize: "1rem" }}>
                                                        <CircularProgressbarWithChildren
                                                            styles={buildStyles({
                                                                pathColor:
                                                                    item.desempenho_solar_instantaneo < 81
                                                                        ? "#fb425c"
                                                                        : item.desempenho_solar_instantaneo > 93
                                                                          ? "#51fd6d"
                                                                          : "#fff127",
                                                                textColor: "#000",
                                                            })}
                                                            value={item.desempenho_solar_instantaneo || 0}
                                                            // text={`${Number(item.potencia_instantanea).toFixed(1).replace(".", ",")} kW\n
                                                            // 		${item.desempenho_potencia_instantanea} %`}
                                                        >
                                                            <div style={{ zIndex: 0 }}>
                                                                <p
                                                                    style={{
                                                                        margin: "11px 0 0 0",
                                                                        fontSize: "0.88rem",
                                                                    }}
                                                                >{`${Number(item.potencia_instantanea).toFixed(1).replace(".", ",")} kW`}</p>
                                                                <p style={{ margin: "-3px 0 0 0", fontSize: "0.7rem" }}>{`${Math.round(item.desempenho_solar_instantaneo)} %`}</p>
                                                            </div>
                                                        </CircularProgressbarWithChildren>
                                                    </div>
                                                ) : (
                                                    <div
                                                        title="Sem Geração de Energia"
                                                        style={{
                                                            borderRadius: "50%",
                                                            border: "5px solid #e3e3e3",
                                                            height: 72,
                                                            width: 73,
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                        }}
                                                    >
                                                        <img alt="" src={noEnergy} width={30} height={30} />
                                                    </div>
                                                )}
                                            </Td>

                                            {props.filtro.id_agrupador ? (
                                                <Td alignCenter minWidth={80}>
                                                    <span style={{ fontSize: "0.9rem" }}>{parseFloat(item.energia_atual).toFixed(1).replace(".", ",")} kWh</span>
                                                </Td>
                                            ) : (
                                                <>
                                                    <Td alignCenter backgroundColor={filtroDesempenho("diario") ? "#eee" : null}>
                                                        <Button
                                                            style={{ width: 80, height: 80, padding: 0, margin: 2 }}
                                                            title={`Ver o gráfico do dia\n${
                                                                parseFloat(item.energia_dia).toFixed(1).replace(".", ",") +
                                                                " kWh de " +
                                                                parseFloat(item.prod_max_esperada_dia_atual).toFixed(1).replace(".", ",")
                                                            } kWh (${item.percentual_producao_energia_dia.toFixed(1).replace(".", ",")}%)`}
                                                            text={
                                                                <SemiCircleProgressBar
                                                                    width={80}
                                                                    height={80}
                                                                    progress={item.desempenho_solar_diario}
                                                                    classColor={"info"}
                                                                    minMaxMedium={[81, 93]}
                                                                >
                                                                    <div style={{ fontSize: "0.8rem" }}>{adicionarPontosMilhar(item.energia_dia, 1)}</div>
                                                                    <div style={{ fontSize: "0.8rem", lineHeight: 0.9 }}>kWh</div>
                                                                    <div style={{ fontSize: "0.7rem" }}>
                                                                        <i className="fas fa-sun mr-1" /> {item.percentual_producao_energia_dia.toFixed(1).replace(".", ",")}%
                                                                    </div>
                                                                    <div
                                                                        style={{
                                                                            fontSize: "0.7rem",
                                                                            color: getCorDesempenho({ valor: item.desempenho_solar_diario, minMaxMedium: [81, 93] }),
                                                                        }}
                                                                    >
                                                                        <i className="fas fa-tachometer-alt mr-1" /> {item.desempenho_solar_diario.toFixed(1).replace(".", ",")}%
                                                                    </div>
                                                                </SemiCircleProgressBar>
                                                            }
                                                            type={"info"}
                                                            event={() => {
                                                                props.setModoTela("graficoEnergiaDia", item);
                                                            }}
                                                        />
                                                    </Td>
                                                    <Td alignCenter backgroundColor={filtroDesempenho("mensal") ? "#eee" : null}>
                                                        <Button
                                                            style={{ width: 80, height: 80, padding: 0, margin: 2 }}
                                                            title={`Ver o gráfico do mês\n${
                                                                parseFloat(item.energia_mes).toFixed(1).replace(".", ",") +
                                                                " kWh de " +
                                                                parseFloat(item.prod_max_esperada_mes_atual).toFixed(1).replace(".", ",")
                                                            } kWh (${item.percentual_producao_energia_mes.toFixed(1).replace(".", ",")}%)`}
                                                            text={
                                                                <SemiCircleProgressBar
                                                                    width={80}
                                                                    height={80}
                                                                    progress={item.desempenho_solar_mensal}
                                                                    classColor={"info"}
                                                                    minMaxMedium={[81, 93]}
                                                                >
                                                                    <div style={{ fontSize: "0.8rem" }}>{adicionarPontosMilhar(item.energia_mes, 1)}</div>
                                                                    <div style={{ fontSize: "0.8rem", lineHeight: 0.9 }}>kWh</div>
                                                                    <div style={{ fontSize: "0.7rem" }}>
                                                                        <i className="fas fa-sun mr-1" /> {item.percentual_producao_energia_mes.toFixed(1).replace(".", ",")}%
                                                                    </div>
                                                                    <div
                                                                        style={{
                                                                            fontSize: "0.7rem",
                                                                            color: getCorDesempenho({ valor: item.desempenho_solar_mensal, minMaxMedium: [81, 93] }),
                                                                        }}
                                                                    >
                                                                        <i className="fas fa-tachometer-alt mr-1" />{" "}
                                                                        {(item.desempenho_solar_mensal || 0).toFixed(1).replace(".", ",")}%
                                                                    </div>
                                                                </SemiCircleProgressBar>
                                                            }
                                                            type={"info"}
                                                            event={() => {
                                                                props.setModoTela("graficoEnergiaDiasMes", item);
                                                            }}
                                                        />
                                                    </Td>
                                                    <Td alignCenter backgroundColor={filtroDesempenho("anual") ? "#eee" : null}>
                                                        <Button
                                                            style={{ width: 80, height: 80, padding: 0, margin: 2 }}
                                                            title={`Ver o gráfico do ano\n${
                                                                parseFloat(item.energia_ano).toFixed(1).replace(".", ",") +
                                                                " kWh de " +
                                                                parseFloat(item.prod_max_esperada_ano_atual).toFixed(1).replace(".", ",")
                                                            } kWh (${item.percentual_producao_energia_ano.toFixed(1).replace(".", ",")}%)`}
                                                            text={
                                                                <SemiCircleProgressBar
                                                                    width={80}
                                                                    height={80}
                                                                    progress={item.desempenho_solar_anual}
                                                                    classColor={"info"}
                                                                    minMaxMedium={[81, 93]}
                                                                >
                                                                    <div style={{ fontSize: "0.8rem" }}>
                                                                        {adicionarPontosMilhar(parseFloat(item.energia_ano) ? parseFloat(item.energia_ano) / 1000 : 0, 1)}
                                                                    </div>
                                                                    <div style={{ fontSize: "0.8rem", lineHeight: 0.9 }}>MWh</div>
                                                                    <div style={{ fontSize: "0.7rem" }}>
                                                                        <i className="fas fa-sun mr-1" /> {item.percentual_producao_energia_ano.toFixed(1).replace(".", ",")}%
                                                                    </div>
                                                                    <div
                                                                        style={{
                                                                            fontSize: "0.7rem",
                                                                            color: getCorDesempenho({ valor: item.desempenho_solar_anual, minMaxMedium: [81, 93] }),
                                                                        }}
                                                                    >
                                                                        <i className="fas fa-tachometer-alt mr-1" />{" "}
                                                                        {(item.desempenho_solar_anual || 0).toFixed(1).replace(".", ",")}%
                                                                    </div>
                                                                </SemiCircleProgressBar>
                                                            }
                                                            type={"info"}
                                                            event={() => {
                                                                props.setModoTela("graficoEnergiaMesesAno", item);
                                                            }}
                                                        />
                                                    </Td>
                                                    <Td alignCenter maxWidth={136} minWidth={136}>
                                                        {item.alerta_desempenho ? (
                                                            <div
                                                                title={
                                                                    (item.percentual_chuva >= 28 && !item.alerta_limpeza_atrasada
                                                                        ? `* Percentual de chuva nos primeiros 10 dias do mês é maior ou igual à 28%: ${adicionarPontosMilhar(
                                                                              item.percentual_chuva
                                                                          )}%\n`
                                                                        : "") + item.alerta_desempenho
                                                                }
                                                                style={{
                                                                    width: 136,
                                                                    height: "100%",
                                                                    backgroundColor: exibirCondicaoAdversa && !item.alerta_limpeza_atrasada ? "#a5b3c1" : "#FF4054",
                                                                    border: exibirCondicaoAdversa && !item.alerta_limpeza_atrasada ? "2px solid #a5b3c1" : "2px solid #E44556",
                                                                    color: "#FFF",
                                                                    borderRadius: "0.3rem",
                                                                    padding: 4,
                                                                    minHeight: 80,
                                                                    fontSize: "0.71rem",
                                                                    lineHeight: "0.71rem",
                                                                    cursor: "help",
                                                                }}
                                                            >
                                                                <img src={alertaDesempenho} alt="" width={50} />
                                                                {exibirCondicaoAdversa && !item.alerta_limpeza_atrasada && <img src={nuvemChuva} alt="" width={40} style={{ margin: 4 }} />}
                                                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>Desempenho baixo!</div>
                                                                {exibirCondicaoAdversa && !item.alerta_limpeza_atrasada ? (
                                                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                                        Condição Climática Adversa
                                                                    </div>
                                                                ) : (
                                                                    <>
                                                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                                            Verifique a necessidade
                                                                        </div>
                                                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>de manutenção/limpeza</div>
                                                                    </>
                                                                )}
                                                            </div>
                                                        ) : (
                                                            <div
                                                                style={{
                                                                    width: 136,
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    backgroundColor: "#D5FFE7",
                                                                    border: "2px solid #CFF3E4",
                                                                    padding: 4,
                                                                    minHeight: 80,
                                                                    borderRadius: "0.3rem",
                                                                    cursor: "help",
                                                                }}
                                                                title={`- Mês passado: ${(item.desempenho_solar_passado_1_mes || 0)
                                                                    .toFixed(1)
                                                                    .replace(".", ",")} %\n- 2 meses atrás: ${(item.desempenho_solar_passado_2_meses || 0)
                                                                    .toFixed(1)
                                                                    .replace(".", ",")} %\n- 3 meses atrás: ${(item.desempenho_solar_passado_3_meses || 0)
                                                                    .toFixed(1)
                                                                    .replace(".", ",")} %\n- 4 meses atrás: ${(item.desempenho_solar_passado_4_meses || 0)
                                                                    .toFixed(1)
                                                                    .replace(".", ",")} %
                                                `}
                                                            >
                                                                <img src={desempenhoOk} alt="" width={50} />
                                                            </div>
                                                        )}
                                                    </Td>
                                                    <Td alignCenter>
                                                        <Button
                                                            title={"Visualizar módulos"}
                                                            style={{
                                                                width: 80,
                                                                height: 80,
                                                                padding: 0,
                                                            }}
                                                            text={
                                                                <div>
                                                                    <p style={{ marginTop: 0, marginBottom: 0 }}>
                                                                        <i className="fas fa-solar-panel" style={{ fontSize: "1.1rem", padding: 10 }}></i>
                                                                    </p>
                                                                    <p style={{ marginBottom: 0 }}>
                                                                        {item.modulos_potencia_total && parseFloat(item.modulos_potencia_total) >= 0
                                                                            ? parseFloat(item.modulos_potencia_total).toFixed(1).replace(".", ",") + " kW"
                                                                            : "-"}
                                                                    </p>
                                                                    <p style={{ fontSize: "0.7rem", margin: 0 }}>Detalhar</p>
                                                                </div>
                                                            }
                                                            type={"info"}
                                                            event={() => {
                                                                props.getModulos(item.id_unidade_consumidora);
                                                                props.setModoTela("modulos", item);
                                                            }}
                                                        />
                                                    </Td>
                                                    <Td alignCenter>
                                                        <Button
                                                            title={"Visualizar dispositivos"}
                                                            style={{
                                                                width: 80,
                                                                height: 80,
                                                                padding: 0,
                                                            }}
                                                            text={
                                                                <div>
                                                                    <p style={{ marginTop: 5, marginBottom: 8 }}>
                                                                        <i
                                                                            style={{
                                                                                fontSize: "1.1rem",
                                                                                verticalAlign: "middle",
                                                                            }}
                                                                            className="fas fa-charging-station"
                                                                        />
                                                                    </p>
                                                                    <p style={{ marginBottom: 0 }}>
                                                                        {item.inversor_potencia_total && parseFloat(item.inversor_potencia_total) >= 0
                                                                            ? parseFloat(item.inversor_potencia_total).toFixed(1).replace(".", ",") + " kW"
                                                                            : "-"}
                                                                    </p>
                                                                    <p style={{ fontSize: "0.7rem", margin: 0 }}>Detalhar</p>
                                                                </div>
                                                            }
                                                            type={"info"}
                                                            event={() => {
                                                                props.setModoTela("dispositivos", item);
                                                            }}
                                                        />
                                                    </Td>
                                                    <Td alignCenter minWidth={104}>
                                                        <>
                                                            <Button
                                                                style={{ width: 104, height: 30, padding: 0, margin: 2 }}
                                                                disabled={!props.usuarioLogado.acesso_manutencao_solar_visualizar}
                                                                title={`Exibir informação de manutenções`}
                                                                text={"Log"}
                                                                icon={`fas fa-cogs`}
                                                                type={"info"}
                                                                event={() => {
                                                                    setState({ ...state, exibirModalLogManutencao: true, itemSelecionado: item });
                                                                }}
                                                            />
                                                            <div style={{ width: 104, height: 40, paddingBlock: 5 }}>
                                                                {item.manutencoes && item.manutencoes.find((l) => l.id_manutencao_tipo == 1) ? (
                                                                    <p
                                                                        style={{
                                                                            fontSize: "0.7rem",
                                                                            lineHeight: "0.8rem",
                                                                            margin: 0,
                                                                            color: item.alerta_limpeza_atrasada ? "#ff0019" : undefined,
                                                                            cursor: item.alerta_limpeza_atrasada ? "help" : undefined,
                                                                        }}
                                                                        title={item.alerta_limpeza_atrasada ? "Já passou de 12 meses desde a última limpeza." : undefined}
                                                                    >
                                                                        <div> Última limpeza:</div>
                                                                        {DateFormat.formatarDataSqlParaTela(item.manutencoes.find((l) => l.id_manutencao_tipo == 1).datahora)}
                                                                    </p>
                                                                ) : (
                                                                    <p style={{ fontSize: "0.7rem", lineHeight: "0.8rem", margin: 0 }}>Nenhuma limpeza realizada</p>
                                                                )}
                                                            </div>
                                                        </>
                                                    </Td>
                                                    {props.filtro.id_agrupador ? null : (
                                                        <>
                                                            <Td alignCenter>
                                                                <DivBox borderColor="#dedede">
                                                                    {item.nome_icone ? (
                                                                        <img alt="" src={weatherIcons[item.nome_icone]} width={40} height={40}></img>
                                                                    ) : (
                                                                        <i
                                                                            className="fas fa-question"
                                                                            style={{
                                                                                color: "#17a2b8",
                                                                                fontSize: "1.5rem",
                                                                            }}
                                                                        ></i>
                                                                    )}
                                                                </DivBox>
                                                            </Td>
                                                            <Td alignCenter width={168} minWidth={168} maxWidth={168}>
                                                                <div className="d-flex flex-wrap">
                                                                    <DivBox borderColor="#dedede" width={54} height={40}>
                                                                        <div style={{ fontSize: "0.7rem" }}>
                                                                            <i className="fas fa-cloud ml-1 mr-1"></i>
                                                                            {parseInt(item.nebulosidade) >= 0 ? parseInt(item.nebulosidade) + " %" : "-"}{" "}
                                                                        </div>
                                                                    </DivBox>

                                                                    <DivBox borderColor="#dedede" width={54} height={40}>
                                                                        <div style={{ fontSize: "0.7rem" }}>
                                                                            <i className="fas fa-tint ml-1 mr-1"></i>
                                                                            {parseInt(item.umidade_relativa_ar) >= 0 ? parseInt(item.umidade_relativa_ar) + " %" : "-"}{" "}
                                                                        </div>
                                                                    </DivBox>
                                                                    <DivBox borderColor="#dedede" width={54} height={40}>
                                                                        <div style={{ fontSize: "0.7rem" }}>
                                                                            <i className="fas fa-temperature-low ml-1 mr-1"></i>
                                                                            {item.temperatura_ar != null ? parseInt(item.temperatura_ar) + " °C" : "-"}
                                                                        </div>
                                                                    </DivBox>
                                                                    <DivBox borderColor="#dedede" width={81} height={40}>
                                                                        <div style={{ fontSize: "0.7rem" }}>
                                                                            <i className="fas fa-cloud-showers-heavy mr-1"></i>
                                                                            {parseInt(item.quantidade_precipitacao) >= 0
                                                                                ? parseInt(item.quantidade_precipitacao) + " mm"
                                                                                : "-"}{" "}
                                                                        </div>
                                                                    </DivBox>
                                                                    <DivBox borderColor="#dedede" width={81} height={40}>
                                                                        <div style={{ fontSize: "0.7rem" }}>
                                                                            <i className="fas fa-wind mr-1"></i>
                                                                            {parseInt(item.velocidade_vento) >= 0 ? parseInt(item.velocidade_vento * 3.6) + " km/h" : "-"}{" "}
                                                                        </div>
                                                                    </DivBox>
                                                                </div>
                                                            </Td>
                                                        </>
                                                    )}
                                                    <Td alignCenter>
                                                        {item.amarelo_nos_ultimos_2_dias ? (
                                                            <div
                                                                style={{
                                                                    height: 30,
                                                                    width: 200,
                                                                    backgroundColor: "#ffc107",
                                                                    borderRadius: "0.3rem",
                                                                    padding: "0.2rem 0.4rem",
                                                                    lineHeight: "0.75rem",
                                                                    fontSize: "0.65rem",
                                                                    margin: 2,
                                                                    cursor: "default",
                                                                }}
                                                            >
                                                                Há mais de 2 dias com parte dos inversores sem produção!
                                                            </div>
                                                        ) : item.energia_zerada_ultimos_2_dias ? (
                                                            <div
                                                                style={{
                                                                    height: 30,
                                                                    width: 200,
                                                                    backgroundColor: "#ffc107",
                                                                    borderRadius: "0.3rem",
                                                                    padding: "0.2rem 1rem",
                                                                    lineHeight: "0.75rem",
                                                                    fontSize: "0.65rem",
                                                                    margin: 2,
                                                                    cursor: "default",
                                                                }}
                                                            >
                                                                Há mais de 2 dias sem produção!
                                                            </div>
                                                        ) : null}
                                                        <Button
                                                            style={{
                                                                height: 30,
                                                                width: 200,
                                                                margin: 2,
                                                                padding: 0,
                                                            }}
                                                            text={<span style={{ fontSize: "0.65rem" }}>Detalhes</span>}
                                                            type={"info"}
                                                            event={() => {
                                                                props.setModoTela("lista", {});
                                                                props.setFiltro({
                                                                    ...props.filtro,
                                                                    id_agrupador: props.filtro.agrupar_por_uc ? item.id_unidade_consumidora : item.id_geracao_integracao,
                                                                });
                                                                buscarDadosTela();
                                                            }}
                                                        />
                                                        {props.filtro.agrupar_por_uc ? (
                                                            <BotaoCalcularAmpliacao
                                                                aguardando={!props.listaCalculoAmpliacaoPorUc.length}
                                                                calculoAmpliacao={calculoAmpliacao}
                                                                event={() =>
                                                                    setState({
                                                                        ...state,
                                                                        itemSelecionado: { ...calculoAmpliacao, nome_unidade_consumidora: item.nome_unidade_consumidora },
                                                                        exibirCalculoAmpliacao: true,
                                                                    })
                                                                }
                                                            />
                                                        ) : null}
                                                    </Td>
                                                </>
                                            )}
                                        </NewTr>
                                    );
                                })}
                            </TBody>
                        </Table>
                    )}
                </ContentCardBody>
            </ContentCard>
        );
    }

    function buscarDadosTela() {
        setState({
            ...state,
            ultima_atualizacao_lista: DateFormat.formatarDataHoraSqlParaTela(DateFormat.getDataHoraAtual()),
        });
        props.setDataGrafico(DateFormat.getDataAtual().replace(/\//g, "-"));
        props.getLista();
    }

    function getStyleSlimCard(bgColor, textColor) {
        return {
            borderRadius: 8,
            cursor: "pointer",
            backgroundColor: bgColor,
            color: textColor,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "10px 10px 0px 10px",
            width: "100%",
            minHeight: "40px",
            margin: 5,
            boxShadow: "#9b9b9b 0px 1px 2px 1px",
        };
    }

    // Sem acessos
    if (!props.usuarioLogado || (!props.usuarioLogado.acesso_solar_visualizar && !props.usuarioLogado.acesso_solar_editar)) {
        return <div />;
    }

    if (props.pdf) {
        return (
            <DisplayPDF
                setDownloadRealizado={() => props.incluirDownloadRealizado([props.id_pdf])}
                closePdf={props.setArquivoPDF}
                pdfBase64={props.pdf}
                nomePdf={props.nomePdf}
                zoomParametro={1.5}
            />
        );
    }
    return (
        <div>
            {props.aguardando ? <Loading /> : null}
            <Content>
                <ModalBalancoEnergetico
                    usarDatahoraMesAnterior={true}
                    itemSelecionado={state.itemSelecionado}
                    visible={state.exibirModalBalancoEnergetico && state.itemSelecionado}
                    handleClose={() => setState({ ...state, exibirModalBalancoEnergetico: false, itemSelecionado: null })}
                />
                <ModalGestorConcessonaria
                    visible={state.exibirModalGestorConcessionaria && state.itemSelecionado && state.itemSelecionado.gestor_concessionaria_energia}
                    itemSelecionado={state.itemSelecionado}
                    handleClose={() => setState({ ...state, exibirModalGestorConcessionaria: false, itemSelecionado: null })}
                />
                <ModalAlert
                    showModal={state.exibirCalculoAmpliacao && !props.pdf && !props.aguardando}
                    titulo=""
                    handleClose={() => setState({ ...state, exibirCalculoAmpliacao: false, itemSelecionado: null })}
                    maxWidth={"95%"}
                >
                    <TabelaCalculoAmpliacao itemSelecionado={state.itemSelecionado} />
                </ModalAlert>
                <ModalAlert
                    showModal={state.exibirModalLogManutencao && state.itemSelecionado && !props.pdf}
                    titulo="Log de manutenções"
                    handleClose={() => setState({ ...state, exibirModalLogManutencao: false, itemSelecionado: null, propsFormularioLogManutencao: {} })}
                >
                    {state.propsFormularioLogManutencao.item ? (
                        <LogManutencaoSolarForm {...state.propsFormularioLogManutencao} />
                    ) : (
                        <LogManutencaoSolarTabela
                            usuarioLogado={props.usuarioLogado}
                            itemSelecionado={state.itemSelecionado}
                            evento={({ acao, item }) => {
                                let handleSubmit = () => ({});
                                let handleClose = () => setState({ ...state, propsFormularioLogManutencao: {} });
                                let tipo;
                                let readOnly = true;

                                if (acao === "ADICIONAR" || acao === "EDITAR") {
                                    handleSubmit = (formValues) =>
                                        props.salvarManutencaoSolarHistorico({
                                            registro: formValues,
                                            callback: handleClose,
                                        });
                                    readOnly = false;
                                    tipo = "SALVAR";
                                }

                                if (acao === "EXCLUIR") {
                                    handleSubmit = (formValues) =>
                                        props.excluirManutencaoSolarHistorico({
                                            registro: formValues,
                                            callback: handleClose,
                                        });
                                    tipo = "EXCLUIR";
                                }

                                //iniciar formulario de inclusão
                                setState({
                                    ...state,
                                    propsFormularioLogManutencao: {
                                        item,
                                        readOnly,
                                        tipo,
                                        handleSubmit,
                                        handleClose,
                                        listaManutencaoTipo: props.listaManutencaoTipo,
                                    },
                                });
                            }}
                        />
                    )}
                </ModalAlert>
                {props.modoTela === "lista" ? listar() : null}
                {props.modoTela === "dispositivos" ? (
                    <GeracaoLeituraInversores item={props.registro} voltar={() => props.setModoTela(state.modoTelaVoltar, state.registroVoltar || {})} />
                ) : null}
                {props.modoTela === "modulos" ? (
                    <GeracaoLeituraModulos modulos={props.modulos} voltar={() => props.setModoTela(state.modoTelaVoltar, state.registroVoltar || {})} />
                ) : null}
                {props.modoTela === "detalharCardMobile" ? (
                    <GeracaoLeituraCardMobile
                        color="#FFF"
                        buttonColor="#222"
                        backgroundColor={corBackgroundMobileCliente}
                        getDadosItem={getDadosItem}
                        getCorDesempenho={getCorDesempenho}
                        getModulos={props.getModulos}
                        exibirManutencoes={(item) => setState({ ...state, exibirModalLogManutencao: true, itemSelecionado: item })}
                        exibirBalancoEnergetico={(item) => setState({ ...state, exibirModalBalancoEnergetico: true, itemSelecionado: item })}
                    />
                ) : null}

                {props.modoTela.includes("grafico") ? (
                    <GeracaoLeituraGraficos
                        voltar={() => {
                            props.setModoTela(state.modoTelaVoltar, state.registroVoltar || {});
                            props.setDataGrafico(DateFormat.getDataAtual().replace(/\//g, "-"));
                        }}
                    />
                ) : null}
            </Content>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        sessao: state.auth.usuario,
        usuarioLogado: state.auth.usuarioLogado,
        modoTela: state.geracaoLeitura.modoTela,
        aguardando: state.geracaoLeitura.aguardando,
        dataGrafico: state.geracaoLeitura.dataGrafico,
        filtro: state.geracaoLeitura.filtro,
        registro: state.geracaoLeitura.registro,
        lista: state.geracaoLeitura.lista,
        modulos: state.geracaoLeitura.modulos,
        listaCliente: state.geracaoLeitura.listaCliente,
        listaUnidadeConsumidora: state.geracaoLeitura.listaUnidadeConsumidora,
        listaManutencaoTipo: state.geracaoLeitura.listaManutencaoTipo,
        listaGeracaoIntegracaoTipo: state.geracaoIntegracao.listaGeracaoIntegracaoTipo,
        listaGraficoEnergiaDia: state.geracaoLeitura.listaGraficoEnergiaDia,
        listaGraficoEnergiaDiasMes: state.geracaoLeitura.listaGraficoEnergiaDiasMes,
        listaGraficoEnergiaMesesAno: state.geracaoLeitura.listaGraficoEnergiaMesesAno,
        listaCalculoAmpliacaoPorUc: state.geracaoLeitura.listaCalculoAmpliacaoPorUc,
        STATUS_COR_AMARELA: state.geracaoLeitura.AMARELA,
        STATUS_COR_VERMELHA: state.geracaoLeitura.VERMELHA,
        STATUS_COR_VERDE: state.geracaoLeitura.VERDE,
        pdf: state.displayPDF.pdf,
        id_pdf: state.displayPDF.id_pdf,
        nomePdf: state.displayPDF.nomePdf,
    };
};
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setEmitirAlertaSonoro,
            setDataGrafico,
            setModoTela,
            setFiltro,
            getLista,
            getModulos,
            getListaCliente,
            getListaUnidadeConsumidora,
            getListaManutencaoTipo,
            getListaGraficoTodasIntegracoesAgrupadasPorHora,
            getListaGraficoEnergiaDia,
            getListaGraficoEnergiaDiasMes,
            getListaGraficoEnergiaMesesAno,
            setStatusVisualizado,
            setAguardando,
            getListaGeracaoIntegracaoTipo,
            salvarManutencaoSolarHistorico,
            excluirManutencaoSolarHistorico,
            gerarRelatorio,
            incluirDownloadRealizado,
            setArquivoPDF,
            incluirEnergiaDia,
            getListaCalculoAmpliacaoPorUc,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(GeracaoLeitura);
